"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.fetcher = exports.PROJECT_IDS = exports.API_BASE_URLS = void 0;
const enums_1 = require("../enums");
const trimTrailingSlash = (value) => value.replace(/\/+$/, '');
const resolveApiBaseUrl = (...values) => {
    for (const value of values) {
        const normalized = value === null || value === void 0 ? void 0 : value.trim();
        if (normalized) {
            return trimTrailingSlash(normalized);
        }
    }
    return '';
};
exports.API_BASE_URLS = {
    [enums_1.Environment.PRODUCTION]: resolveApiBaseUrl(process.env.NEXT_PUBLIC_PRODUCTION_API_URL, process.env.REACT_APP_PUBLIC_PRODUCTION_API_URL),
    [enums_1.Environment.STAGING]: resolveApiBaseUrl(process.env.NEXT_PUBLIC_STAGING_API_URL, process.env.REACT_APP_PUBLIC_STAGING_API_URL),
    [enums_1.Environment.DEVELOPMENT]: resolveApiBaseUrl(process.env.NEXT_PUBLIC_DEVELOPMENT_API_URL, process.env.REACT_APP_PUBLIC_DEVELOPMENT_API_URL)
};
exports.PROJECT_IDS = {
    [enums_1.Environment.PRODUCTION]: 'dade-auctions-b98d3',
    [enums_1.Environment.STAGING]: 'dade-auctions-stage-c6e2a',
    [enums_1.Environment.DEVELOPMENT]: 'dade-auctions-dev'
};
const APP_CHECK_HEADER = 'X-Firebase-AppCheck';
const getRegisteredIdToken = () => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof window === 'undefined') {
        return null;
    }
    const getIdToken = window.__DADE_GET_ID_TOKEN__;
    if (typeof getIdToken !== 'function') {
        return null;
    }
    try {
        return yield getIdToken();
    }
    catch (_a) {
        return null;
    }
});
const waitForBrowserUser = () => __awaiter(void 0, void 0, void 0, function* () {
    const { getAuth, onAuthStateChanged } = yield Promise.resolve().then(() => __importStar(require('firebase/auth')));
    const auth = getAuth();
    if (auth.currentUser) {
        return auth.currentUser;
    }
    return new Promise((resolve) => {
        const timeoutId = window.setTimeout(() => {
            unsubscribe();
            resolve(auth.currentUser);
        }, 5000);
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            window.clearTimeout(timeoutId);
            unsubscribe();
            resolve(user);
        }, () => {
            window.clearTimeout(timeoutId);
            unsubscribe();
            resolve(auth.currentUser);
        });
    });
});
const getAuthorizationHeader = () => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof window === 'undefined') {
        return {};
    }
    try {
        const registeredToken = yield getRegisteredIdToken();
        if (registeredToken) {
            return { Authorization: `Bearer ${registeredToken}` };
        }
        const user = yield waitForBrowserUser();
        if (!user) {
            return {};
        }
        const token = yield user.getIdToken();
        return token ? { Authorization: `Bearer ${token}` } : {};
    }
    catch (_b) {
        return {};
    }
});
const getAppCheckHeader = () => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof window === 'undefined') {
        return {};
    }
    const getAppCheckToken = window
        .__DADE_GET_APP_CHECK_TOKEN__;
    if (typeof getAppCheckToken !== 'function') {
        return {};
    }
    try {
        const token = yield getAppCheckToken();
        return token ? { [APP_CHECK_HEADER]: token } : {};
    }
    catch (_c) {
        return {};
    }
});
const DEFAULT_FETCH_TIMEOUT_MS = 15000;
const normalizedErrorData = (response, body) => {
    const record = body && typeof body === 'object' && !Array.isArray(body)
        ? body
        : {};
    return Object.assign(Object.assign({}, record), { code: typeof record.code === 'number'
            ? record.code
            : response
                ? response.ok
                    ? 502
                    : response.status
                : 503, status: false, msg: typeof record.msg === 'string' && record.msg.trim()
            ? record.msg
            : typeof record.message === 'string' && record.message.trim()
                ? record.message
                : response
                    ? `Request failed with status ${response.status}.`
                    : 'Unable to reach the server. Please try again.' });
};
const fetcher = (url, method, body, options = {}) => __awaiter(void 0, void 0, void 0, function* () {
    var _d, _e, _f, _g;
    const authHeader = yield getAuthorizationHeader();
    const appCheckHeader = yield getAppCheckHeader();
    const controller = new AbortController();
    const timeoutMs = Math.max(1, (_d = options.timeoutMs) !== null && _d !== void 0 ? _d : DEFAULT_FETCH_TIMEOUT_MS);
    const abortFromCaller = () => { var _a; return controller.abort((_a = options.signal) === null || _a === void 0 ? void 0 : _a.reason); };
    if ((_e = options.signal) === null || _e === void 0 ? void 0 : _e.aborted) {
        controller.abort(options.signal.reason);
    }
    else {
        (_f = options.signal) === null || _f === void 0 ? void 0 : _f.addEventListener('abort', abortFromCaller, { once: true });
    }
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
    let response;
    try {
        response = yield fetch(`${url}`, Object.assign(Object.assign({ headers: Object.assign(Object.assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, appCheckHeader), authHeader), method: method }, (body && { body: JSON.stringify(Object.assign({}, body)) })), { signal: controller.signal }));
    }
    catch (error) {
        return {
            data: normalizedErrorData(),
            error
        };
    }
    finally {
        clearTimeout(timeoutId);
        (_g = options.signal) === null || _g === void 0 ? void 0 : _g.removeEventListener('abort', abortFromCaller);
    }
    let data = null;
    try {
        const text = yield response.text();
        data = text ? JSON.parse(text) : null;
    }
    catch (error) {
        return {
            data: normalizedErrorData(response),
            error
        };
    }
    if (!response.ok) {
        return {
            data: normalizedErrorData(response, data),
            error: new Error(`Request failed with status ${response.status}.`)
        };
    }
    return { data };
});
exports.fetcher = fetcher;
exports.methods = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE'
};
